import { CoordinatorService } from './coordinator.service';
import { Databin } from './databin';
import { ScriptBase } from './script-base';
import { ScriptHitset } from './script-hitset';
import { ScriptInput } from './script-input';
import { ScriptOutput } from './script-output';

export class ScriptDatabin extends ScriptBase {
    #coords: CoordinatorService;
    #_databin: Databin;

    constructor(coords: CoordinatorService, _databin: Databin) {
        super(coords, _databin);
        this.#coords = coords;
        this.#_databin = _databin;
    }

    get target() {
        return this.#_databin;
    }

    resource(title: string | RegExp) {
        for (const r of this.resourceList()) {
            if (r.test(title)) return r;
        }
        return null;
    }

    resourceList() {
        return this.#_databin.connectionLs.map((c) => c.scriptClass);
    }

    hitset(isPreview = false) {
        const nH = new ScriptHitset(this.#coords, isPreview);

        return this._hitset(nH, this.#_databin.activeXitemIdSet, true);
    }

    on() {
        this.#_databin.isOn = true;
    }

    off() {
        this.#_databin.isOn = false;
    }

    log(prefix = 'Databin') {
        console.log(`${prefix}: ${this.#_databin.title} SIZE: ${this.#_databin.size}`);
        return this;
    }

    json(onlyActiveResources = false) {
        return this.#_databin.json(onlyActiveResources);
    }

    display() {
        const stg = this.#coords.script$.stage('databin');
        stg?.display();
        this.#_databin.setCurrent();
        return this;
    }

    delete() {
        this.#_databin.delete();
    }

    export() {
        const out = new ScriptOutput(this.#coords);
        out.addDatabins(this);
        out.save({ title: this.title, suffix: 'databin.ref' });
    }

    async duplicate() {
        const out = new ScriptOutput(this.#coords);
        out.addDatabins(this);
        const blob = await out.save({ returnBlob: true });
        const inp = new ScriptInput(this.#coords);
        await inp.process(blob!);
        inp.importDatabins(true);
    }
}
